import logo1 from '@/public/images/1.png';
import logo2 from '@/public/images/2.png';
import logo3 from '@/public/images/3.png';
import logo4 from '@/public/images/4.png';
import logo5 from '@/public/images/5.png';
import logo6 from '@/public/images/6.png';
import logo7 from '@/public/images/7.png';
import logo8 from '@/public/images/8.png';
import logo9 from '@/public/images/9.png';
import logo10 from '@/public/images/10.png';
import logo11 from '@/public/images/11.png';
import logo12 from '@/public/images/12.png';
import logo13 from '@/public/images/13.png';
import logo14 from '@/public/images/14.png';
import logo15 from '@/public/images/15.png';
import logo16 from '@/public/images/16.png';
import logo17 from '@/public/images/17.png';
import logo18 from '@/public/images/18.png';
import logo19 from '@/public/images/19.png';
import logo20 from '@/public/images/20.png';
import logo21 from '@/public/images/21.png';
import logo22 from '@/public/images/22.png';
import logo23 from '@/public/images/23.png';
import logo24 from '@/public/images/24.png';
import logo25 from '@/public/images/25.png';
import logo26 from '@/public/images/26.png';
import logo27 from '@/public/images/27.png';
import logo28 from '@/public/images/28.png';
import logo29 from '@/public/images/29.png';
import logo30 from '@/public/images/30.png';
import logo31 from '@/public/images/31.png';
import logo32 from '@/public/images/32.png';
import logo33 from '@/public/images/33.png';
import logo34 from '@/public/images/34.png';
import logo35 from '@/public/images/35.png';
import logo36 from '@/public/images/36.png';
import logo37 from '@/public/images/37.png';
import logo38 from '@/public/images/38.png';
import logo39 from '@/public/images/39.png';
import logo40 from '@/public/images/40.png';
import logo41 from '@/public/images/41.png';
import logo42 from '@/public/images/42.png';
import logo43 from '@/public/images/namdeo.png';
import logo44 from '@/public/images/super_seeds_1.png';
import logo45 from '@/public/images/mahindra_summit.png';
import logo46 from '@/public/images/mahindra_rise_1.png';
import logo47 from '@/public/images/mahindra_hzpc.png';
import logo48 from '@/public/images/cultivatec.png';
import logo49 from '@/public/images/basant.png';
import logo50 from '@/public/images/united_genetics.png';
import logo51 from '@/public/images/sunrise1.png';
import logo52 from '@/public/images/fertibase.png';
import logo53 from '@/public/images/farmvista.png';
import logo54 from '@/public/images/albaugh.png';



export const logoImages = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
  logo19,
  logo20,
  logo21,
  logo22,
  logo23,
  logo24,
  logo25,
  logo26,
  logo27,
  logo28,
  logo29,
  logo30,
  logo31,
  logo32,
  logo33,
  logo34,
  logo35,
  logo36,
  logo37,
  logo38,
  logo39,
  logo40,
  logo41,
  logo42,
  logo43,
  logo44,
  logo45,
  logo46,
  logo47,
  logo48,
  logo49,
  logo50,
  logo51,
  logo52,
  logo53,
];
